import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArrowLinkGroup from '~/client/components/arrow-link-group/arrow-link-group';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import Categories from '~/client/components/categories/categories';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { MemberCareCategoryPage as Props } from './member-care-category-page.types';

const MemberCareCategoryPage: React.FunctionComponent<Props> = ({
  breadcrumbs,
  description,
  layout,
  subcategories,
  otherCategories,
  title,
}) => (
  <Layout {...layout}>
    <Breadcrumbs {...breadcrumbs} />
    <ContentContainer>
      <div className="member-care-category-page__main">
        <Text
          elementName="h1"
          italic
          size={Text.sizes.headline2}
          theme={Text.themes.headline}
        >
          {title}
        </Text>
        {description ? <Text elementName="p">{description}</Text> : null}
        <ArrowLinkGroup {...subcategories} />
      </div>
    </ContentContainer>
    <div className="member-care-category-page__other-categories">
      <ContentContainer>
        <Categories {...otherCategories} />
      </ContentContainer>
    </div>
  </Layout>
);

export default MemberCareCategoryPage;
